import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageEvent } from '@tesla/ng-tds';
import { EDIStatus } from 'app/profile/models/edi-status.model';
import { EDIStatusService } from 'app/profile/services/edi-status.service';
import { I18nService } from 'app/shared/services/i18n.service';
import { BehaviorSubject, Subscription } from 'rxjs-compat';
import { TabComponent } from '../tab-component';

@Component({
  selector: 'app-edi-status',
  templateUrl: './edi-status.component.html',
  styleUrls: ['./edi-status.component.scss']
})
export class EdiStatusComponent implements OnInit, TabComponent, OnDestroy{

  data: any;
  supplierCode: string;
  code: string;

  skip = 0;
  pageSize = 10;

  subscription: Subscription = new Subscription;
  gridViewData: BehaviorSubject<Array<EDIStatus>> = null;
  supplierEDIChannels : Array<EDIStatus>;

  displayedColumns = [
    "EDI",
    "STATUS", 
  ]

  totalRows = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100, 250];
  currentPageSize = 10;

  constructor(private activatedRoute: ActivatedRoute, 
    private ediStatusService: EDIStatusService,
    public translateService: I18nService,
  ) {
  this.gridViewData = new BehaviorSubject([])
  }
 
  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe((params) => {
      if(!params['code']){
        return;
      }
      this.code = params['code'];

      let ediStatusSub = this.ediStatusService.getEDIStatusList(this.code).subscribe((edistatus: EDIStatus[] ) => {
        if(!edistatus){
          return;
        }

        this.supplierEDIChannels = edistatus;
        this.totalRows = edistatus.length;
        this.currentPageSize = this.pageSizeOptions[0];
        this.loadGrid(this.currentPageSize, 0);

      });

      this.subscription.add(ediStatusSub); 
      
    })
  }

  loadGrid(take: number, skip: number) {
    let edilist = this.supplierEDIChannels.slice(skip, skip + take);
    this.gridViewData.next(edilist);
  }

  pageChange(pageChange: PageEvent) {
    const { previousPageIndex, pageSize, pageIndex } = pageChange;
    this.currentPageSize = pageSize;

    if (previousPageIndex === pageIndex) {
      this.loadGrid(pageSize, 0);
    } else {
      const from = pageIndex * pageSize;
      const to = from + pageSize;
      this.loadGrid(pageSize, from);
    }
  }
  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isDirty(): boolean {
   return false;
  }
}
